module.exports = __webpack_public_path__ + "static/media/ZoomIn2.svg";